import PropTypes from "prop-types";
import React, { useState } from "react";
import { useEffect } from "react";
import XmlSection2 from "../XmlViewer/XmlViewer2";
import { toggleFunction } from "../../utils/Functions/toggleFunction";

const InwardXml = (props) => {
  const {
    prev,
    next,
    title,
    request,
    response,
    optiontitle1,
    optiontitle2,
    handleCase1,
    handleCase2,
    isLoading,
  } = props;

  const [state, setState] = useState({
    case1: true,
  });

  useEffect(
    () => {
      setState({
        case1: true,
      });
      handleCase1();
    },
    // eslint-disable-next-line
    []
  );

  const handleChange = toggleFunction(setState, state, handleCase1, handleCase2);

  return (
    <div className="inward-xml-wrap">
      <div className="inward-xml-wrap-header">
        <div className="nip-home-interaction-env-left-back" data-testid="prev" onClick={() => prev()}>
          <p>{"<"}</p> &nbsp;
          <span>Back</span>
        </div>
        <div className="inward-xml-wrap-header-title">{title}</div>
        <div className="inward-xml-wrap-header-title2">
          Run tests, requests and responses, make API Calls and perform other
          related activities.
        </div>
        <div className="inward-xml-wrap-dropselect">
          <label className="inward-xml-wrap-dropselect-label">Test Cases</label>
          <div className="inward-xml-wrap-dropselect-box">
            <select
              className="inward-xml-wrap-dropselect-box-select"
              data-testid="handleChange"
              onChange={() => handleChange()}
            >
              <option value="" disabled>
                Select Test Cases
              </option>
              <option value="1" defaultValue className="default">
                {optiontitle1}
              </option>
              <option value="2">{optiontitle2}</option>
            </select>
          </div>
        </div>
      </div>
      <XmlSection2
        request={request}
        response={response}
        url={"api.nibss.com/transaction/initialize"}
        isLoading={isLoading}
      />

      <div className="retry-btn2">
        <button className="button-next2" type="button" onClick={() => next()} data-testid="next"
        >
          Next
        </button>
      </div>
    </div>
  );
};

InwardXml.propTypes = {
  handleCase1: PropTypes.func,
  handleCase2: PropTypes.func,
  isLoading: PropTypes.bool,
  next: PropTypes.func,
  optiontitle1: PropTypes.string,
  optiontitle2: PropTypes.string,
  prev: PropTypes.func,
  request: PropTypes.string,
  response: PropTypes.string,
  title: PropTypes.string,
};

export default InwardXml;

